export default (val: string): number =>
  Number(val?.split(".")[0]?.replaceAll(",", ""));
